module.exports = __webpack_public_path__ + "img/photo_2023-06-04 10.55.32.665d5e30.jpeg";